// Entrypoint principale per Vite + Rails

// --- Turbo (Hotwire)
import "@hotwired/turbo-rails"

// === Loader management ===
const showLoader = () => {
  document.body.classList.remove("loaded")
}

const hideLoader = () => {
  document.body.classList.add("loaded")
}

// Initial page load - multiple events to ensure it works
window.addEventListener("load", hideLoader)
document.addEventListener("DOMContentLoaded", hideLoader)

// Turbo navigation events
document.addEventListener("turbo:visit", showLoader)
document.addEventListener("turbo:before-visit", showLoader)
document.addEventListener("turbo:load", hideLoader)
document.addEventListener("turbo:render", hideLoader)
document.addEventListener("turbo:before-cache", hideLoader)

// Handle fetch errors - always hide loader
document.addEventListener("turbo:fetch-request-error", hideLoader)

// Fallback: if for some reason the loader is still visible after 3 seconds, hide it
setTimeout(() => {
  if (!document.body.classList.contains("loaded")) {
    hideLoader()
  }
}, 3000)

// --- Stimulus
import { Application } from '@hotwired/stimulus'
import { registerControllers } from 'stimulus-vite-helpers'

import Swal from "sweetalert2"

const application = Application.start()
const controllers = import.meta.glob('../../javascript/controllers/**/*_controller.js', { eager: true })
registerControllers(application, controllers)

application.debug = false
window.Stimulus = application

// --- Styles (Tailwind + librerie UI)
import '../styles/tail_admin.css'
import '../styles/cerquity.css'

import 'sweetalert2/dist/sweetalert2.min.css'
import 'tom-select/dist/css/tom-select.css'
